<template>
    <div class="page">
        <ion-grid class="page-content">
            <ion-row class="row-divider"></ion-row>
            <ion-row class="rectangle">
                <ion-col>
                    <ion-row align-items-stretch>
                        <ion-col size="12" class="col-padding">
                            <ion-label
                                class="light-text"
                            >Enter the OTP sent to your registered mobile {{this.mobile}}</ion-label>
                        </ion-col>
                    </ion-row>
                    <ion-row align-items-stretch>
                        <ion-col size="12" class="col-padding">
                            <div class="border-line">
                                <ion-col>
                                    <ion-input
                                        id="otp"
                                        type="tel"
                                        maxlength="4"
                                        v-model="otp"
                                        autofocus
                                        placeholder="* * * *"
                                        @input="otpController"
                                        class="otp-input"
                                    ></ion-input>
                                    <!-- <ion-input
                                        type="tel"
                                        autofocus="true"
                                        id="otp1"
                                        #otp1
                                        placeholder="*"
                                        required
                                        maxlength="1"
                                        @input="otp1 = $event.target.value"
                                        @keyup="otpController($event, 'otp2')"
                                    ></ion-input> -->
                                    <!-- <ion-input
                                        type="tel"
                                        id="otp2"
                                        #otp2
                                        placeholder="*"
                                        required
                                        maxlength="1"
                                        @input="otp2 = $event.target.value"
                                        @keyup="otpController($event, 'otp3')"
                                    ></ion-input> -->
                                    <!-- <ion-input
                                        type="tel"
                                        id="otp3"
                                        #otp3
                                        placeholder="*"
                                        required
                                        maxlength="1"
                                        @input="otp3 = $event.target.value"
                                        @keyup="otpController($event, 'otp4')"
                                    ></ion-input> -->
                                    <!-- <ion-input
                                        type="tel"
                                        id="otp4"
                                        #otp4
                                        placeholder="*"
                                        required
                                        maxlength="1"
                                        @input="otp4 = $event.target.value"
                                        @keyup="otpController($event, undefined)"
                                    ></ion-input> -->
                                </ion-col>
                            </div>
                        </ion-col>
                    </ion-row>
                    <ion-row text-center class="row-margin">
                        <ion-col>
                            <ion-label class="primary-text-link" @click="resendOtp">Resend OTP</ion-label>
                            <span class="primary-text-link" v-if="disableotp">( {{counter}} )</span>
                        </ion-col>
                    </ion-row>
                </ion-col>
            </ion-row>
        </ion-grid>
    </div>
</template>

<script>
import { defineComponent } from "vue";
import { IonGrid, IonRow, IonCol, IonLabel, IonInput } from "@ionic/vue";
import { AuthenticationService } from "../../service/account/authenticator.service";
import { LocalStorage } from "../../data/localstorage";
import { User } from "../../entity/authentication/user";
import { ValidationUtils } from "../../util/validation-utils";
import { ToastUtils } from "../../util/toast-utils";
import { AlertUtils } from "../../util/alert-utils";
import { tryParseServiceError, migratedTryParseServiceError } from "../../service";

export default defineComponent ({
    name: 'passwordOTPVerify',
    components: {
        IonGrid, IonRow, IonCol, IonLabel, IonInput
    },
    data() {
        return {
            counter: 0,
            disableotp: true,
            mobile: "",
            otp: "",
            otp1: "",
            otp2: "",
            otp3: "",
            otp4: ""
        }   
    },
    mounted() {
        this.mobile = new LocalStorage().mobile;
        this.startCountdown(30);
        // this.setFirstFocus();
    },
    methods: {
        // setFirstFocus() {
        //     document.getElementById("otp1").setFocus();
        // },
        startCountdown(seconds) {
            this.counter = seconds;

            var interval = setInterval(() => {
                this.counter--;

                if (this.counter <= 0) {
                    // The code here will run when
                    // the timer has reached zero.

                    clearInterval(interval);
                    this.disableotp = false;
                }
            }, 1000);
        },
        async resendOtp() {
            if (!this.disableotp) {
                try {
                    let otp = await new AuthenticationService().resendOtpForUser(
                        new LocalStorage().user
                    );
                    new ToastUtils().presentToast("OTP resent to your mobile number");
                    this.disableotp = true;
                    this.startCountdown(30);
                } catch (error) {
                    // let serviceError = tryParseServiceError(error);
                    // new AlertUtils().presentAlert(serviceError ? serviceError : error);
                    // new ToastUtils().presentToast(error.response.data.errors[0].detail);
                    let serviceError = migratedTryParseServiceError(error);
                    new ToastUtils().presentToast(serviceError.description);
                }
            }
        },
        // async otpController(event, next) {
        //     try {
        //         if (event.target.value.length > 0) {
        //         if (next) {
        //             document.getElementById(next).setFocus();
        //         } else {
        //             this.otp = this.otp1 + this.otp2 + this.otp3 + this.otp4;
        //             if (this.otp.length == 4) {
        //             await new AuthenticationService().verifyOtpForUserWithMobileNo(
        //                 this.otp,
        //                 new LocalStorage().user,
        //                 this.mobile
        //             );
        //             new LocalStorage().otp = this.otp;
        //             new ToastUtils().presentToast("OTP verification successfull");
        //             this.$router.push("/resetpassword");
        //             }
        //         }
        //         }
        //     } catch (error) {
        //         // let serviceError = tryParseServiceError(error);
        //         // new AlertUtils().presentAlert(serviceError ? serviceError : error);
        //         let serviceError = migratedTryParseServiceError(error);
        //         if(serviceError.code == "U10010"){
        //             this.$router.push("/login");
        //         }else if (serviceError.code == "U10011") {
        //             this.$router.push("/forgotpassword");
        //         } else {
        //             document.getElementById("otp1").value = null;
        //             document.getElementById("otp2").value = null;
        //             document.getElementById("otp3").value = null;
        //             document.getElementById("otp4").value = null;
        //             this.otp1 = null;
        //             this.otp2 = null;
        //             this.otp3 = null;
        //             this.otp4 = null;
        //             document.getElementById("otp1").setFocus();
        //         }
        //     }
        // }

        async otpController() {
            if (this.otp.length === 4) {
                try {
                await new AuthenticationService().verifyOtpForUserWithMobileNo(
                    this.otp,
                    new LocalStorage().user,
                    this.mobile
                );
                new LocalStorage().otp = this.otp;
                new ToastUtils().presentToast("OTP verification successful");
                this.$router.push("/resetpassword");
                } catch (error) {
                const serviceError = migratedTryParseServiceError(error);
                if (serviceError.code === "U10010") {
                    this.$router.push("/login");
                } else if (serviceError.code === "U10011") {
                    this.$router.push("/forgotpassword");
                } else {
                    this.otp = "";
                    setTimeout(() => document.getElementById("otp")?.setFocus(), 100);
                    new ToastUtils().presentToast(serviceError.description);
                }
                }
            }
        }

    }
})
</script>

<style scoped>
ion-input {
  --highlight-color-focused : none;
  --highlight-color-valid : none;
  display: inline-block;
  width: 310px;
  height: 48px;
  margin: 1px;
  --background: #ffffff;
  --padding-start: 7px;
  text-align: center;
}
.otp-input {
  letter-spacing: 10px; 
  font-size: 17px;      
  text-align: center;    
}
</style>